<template>
  <div v-if="isMounted" class="px-lg-2 user-review position-relative">
    <!--
      No admin tools (edit review, view customer) here, unlike CustomerReview:
      the v2 hashes of an expert review are not the legacy hashids the admin
      backend decodes (VIP-12633).
    -->
    <div class="d-flex flex-column">
      <ReviewHeader
        :title="review.name ?? ''"
        :img-src="review.profile_image"
        :score="review.score"
        :disabled="!review.customer_hash"
      >
        <template #details>
          <CustomerChunk
            v-if="review.customer_hash"
            :expert-review="true"
            :customer-hash="review.customer_hash"
            class="pb-3"
          />
        </template>
        <template #sub>
          <span class="c-gray l-spacing-half font-size-s font-weight-bold">
            <span class="font-size-xxl"> {{ review.score }}</span>
            {{ scoreOutOfMax }}
          </span>
        </template>
      </ReviewHeader>
      <div class="quote mt-3 pa-0 styled-text">
        {{ review.description }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import ReviewHeader from '../atoms/ReviewHeader.vue'

const CustomerChunk = defineAsyncComponent(
  () => import('@/components/pdp/atoms/CustomerChunk.vue')
)
const LUCA_MARONI = 'Luca Maroni'

export default {
  components: {
    ReviewHeader,
    CustomerChunk
  },
  props: { review: Object },
  data() {
    return {
      // Client-only, as it was while the admin tools' lazy import gated it:
      // the review popup has never been part of a server render
      isMounted: false
    }
  },
  computed: {
    scoreOutOfMax() {
      // The API's max_score is the review's own scale; the name check only
      // covers a cached product from before it was sent (VIP-12633)
      const maxScore =
        this.review.max_score ?? (this.review.name === LUCA_MARONI ? 99 : 100)
      return this.translate('fe_app_pdp_out_of_x', maxScore)
    }
  },
  mounted() {
    this.isMounted = true
  }
}
</script>

<style scoped>
.user-review:not(:last-child) {
  border-bottom: 2px solid rgb(var(--v-theme-light-beige));
  padding-bottom: 1rem;
  padding-top: 1rem;
}
.user-review:last-child {
  padding-top: 1rem;
}
</style>
